import React from "react";

const ServiceHighlights = () => {
  const services = [
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 1H6v8l4-2 4 2V6z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Custom Software Development",
      description:
        "Build scalable, secure, and customized software tailored to your business needs.",
      link: "/services/custom-software-development",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Mobile Application Development",
      description:
        "Intuitive and high-performing iOS & Android mobile applications.",
      link: "/services/mobile-app-development",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Odoo Services",
      description:
        "Complete Odoo ERP services including customization, support, and implementation.",
      link: "/services/odoo-services",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Integration",
      description:
        "Seamlessly connect APIs, platforms, and systems for efficiency.",
      link: "/services/integration",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
          <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
          <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
        </svg>
      ),
      title: "Big Data",
      description:
        "Unlock insights with advanced data analytics, storage, and processing.",
      link: "/services/big-data",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 mx-auto"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Consulting",
      description:
        "Expert IT consulting to align technology with your business goals.",
      link: "/services/consulting",
    },
  ];

  return (
    <section className="relative bg-gray-900 text-white py-16 overflow-hidden">
      {/* Blurred Background Layer */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/assets/images/about/bg.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          filter: "blur(0px) brightness(0.5)",
        }}
      ></div>

      {/* Overlay Layer to add a dark transparent tint */}
      <div className="absolute inset-0 bg-white/10 z-0"></div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl font-bold text-white mb-4 uppercase tracking-wide">
          Our Services
        </h2>
        <div class="w-20 h-1 bg-white mx-auto mb-6"></div>
        <p className="max-w-3xl mx-auto text-lg text-white mb-12">
          We provide a wide range of IT services tailored to help businesses
          grow, optimize operations, and stay competitive in the digital world.
        </p>

        {/* Grid for Services */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className="p-6 bg-white rounded-xl shadow-lg backdrop-blur-xl hover:scale-105 hover:shadow-xl transition block"
            >
              <div className="mb-4 flex justify-center">
                <div className="w-14 h-14 mb-4 flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
                  {service.icon}
                </div>
              </div>
              <h3 className="text-xl text-black font-semibold mb-2">
                {service.title}
              </h3>
              <p className="text-gray-700 text-sm">{service.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlights;
